import { Children, cloneElement } from 'react';

import type { ReactElement } from 'react';
import type React from 'react';

export declare module foreach {
  interface Iterable<T> {
    data?: T;
  }

  interface Props<
    T extends
      & {
        id?: string | null | undefined;
      }
      & {
        [Key in keyof T]: T[Key];
      } = { id?: string | null | undefined },
  > {
    items?: T[];
    children?:
      | ReactElement<Iterable<T>, string>
      | Array<ReactElement<Iterable<T>, string>>
      | ((data: T) => React.JSX.Element);
  }
}

/**
 *  is cloning its children and passing a data object its children for each element of the items array
 *  @deprecated - use "shared/react/components/feature-for-each" instead
 */
export const ForEach = <T,>({
  items = [],
  children,
  ...props
}: foreach.Props<T>): React.JSX.Element | null => {
  if (!children) return null;

  // make ForEach work with RenderProps
  if (typeof children === 'function') {
    return (
      <>
        {items.map((item) => children( item ))}
      </>
    );
  }

  const Child = Children.only( children );

  return (
    <>
      {items.map((item, index) =>
        cloneElement( Child, {
          key: item.id ?? index,
          data: item,
          ...props,
        } )
      )}
    </>
  );
};
